import React from 'react'

const TableActionsContainer: React.FC = ({ children }) => {
  return <div style={{ display: 'flex', justifyContent: 'flex-end' }}>{children}</div>
}

export default TableActionsContainer
